import EmpresasAPI from 'dashboard/api/empresas';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  meta: {
    count: 0,
    currentPage: 1,
    totalPages: 1,
  },
};

const getters = {
  getEmpresas: $state => $state.records,
  getEmpresaUIFlags: $state => $state.uiFlags,
  getEmpresaMeta: $state => $state.meta,
  getEmpresaById: $state => id =>
    $state.records.find(c => Number(c.id) === Number(id)),
};

const actions = {
  async fetchEmpresas({ commit }, params = {}) {
    commit('setEmpresaUIFlag', { isFetching: true });
    try {
      const response = await EmpresasAPI.get(params);
      commit('setEmpresas', response.data.payload);
      commit('setEmpresaMeta', response.data.meta);
      return response.data;
    } finally {
      commit('setEmpresaUIFlag', { isFetching: false });
    }
  },

  async fetchEmpresa({ commit }, { id }) {
    commit('setEmpresaUIFlag', { isFetchingItem: true });
    try {
      const response = await EmpresasAPI.show(id);
      commit('addOrUpdateEmpresa', response.data);
      return response.data;
    } finally {
      commit('setEmpresaUIFlag', { isFetchingItem: false });
    }
  },

  async createEmpresa({ commit }, empresaData) {
    commit('setEmpresaUIFlag', { isCreating: true });
    try {
      const response = await EmpresasAPI.create(empresaData);
      commit('addOrUpdateEmpresa', response.data);
      return response.data;
    } finally {
      commit('setEmpresaUIFlag', { isCreating: false });
    }
  },

  async updateEmpresa({ commit }, { id, ...empresaData }) {
    commit('setEmpresaUIFlag', { isUpdating: true });
    try {
      const response = await EmpresasAPI.update(id, empresaData);
      commit('addOrUpdateEmpresa', response.data);
      return response.data;
    } finally {
      commit('setEmpresaUIFlag', { isUpdating: false });
    }
  },

  async deleteEmpresa({ commit }, id) {
    commit('setEmpresaUIFlag', { isDeleting: true });
    try {
      await EmpresasAPI.delete(id);
      commit('removeEmpresa', id);
    } finally {
      commit('setEmpresaUIFlag', { isDeleting: false });
    }
  },
};

const mutations = {
  setEmpresaUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  setEmpresas($state, empresas) {
    $state.records = empresas || [];
  },
  setEmpresaMeta($state, meta = {}) {
    $state.meta = {
      count: meta.count || 0,
      currentPage: meta.current_page || 1,
      totalPages: meta.total_pages || 1,
    };
  },
  addOrUpdateEmpresa($state, empresa) {
    if (!empresa || !empresa.id) return;
    const index = $state.records.findIndex(c => c.id === empresa.id);
    if (index === -1) {
      $state.records = [empresa, ...$state.records];
    } else {
      const next = [...$state.records];
      next[index] = empresa;
      $state.records = next;
    }
  },
  removeEmpresa($state, id) {
    $state.records = $state.records.filter(c => c.id !== id);
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
